<template>
    <form-container headerText="Berechtigungen ändern" :width="450" action="editUserRoles"
                    :valid-actions="['editUserRoles']" @save="save" >
        <div class="mx-7 subtitle-1">
            {{currentObject.firstName}} {{currentObject.lastName}}</div>
        <div class="mx-7 caption mb-5">
            {{currentObject.email}}</div>
        <div v-for="(permission, i) in authorizedPermissions" :key="i" class="mb-3">
            <v-text-field v-if="permission.type==='string'"
                          v-model="permission.value" hide-details
                          :label="permission.label" class="mx-7 mt-4" >
            </v-text-field>
            <v-checkbox v-else-if="permission.type==='boolean'" hide-details
                        v-model="permission.value" color="primary"
                        :label="permission.label" class="mx-7 mt-6">
            </v-checkbox>
        </div>
        <div class="px-7">
            <v-tabs v-model="tab" grow>
                <v-tab>Sportobmann</v-tab>
                <v-tab>Meisterschaften</v-tab>
                <v-tab-item>
                    <div v-for="(permission, i) in authorizedPermissionsSport" :key="i" class="mb-3">
                        <v-checkbox v-if="permission.type==='boolean'" hide-details
                                    v-model="permission.value" color="primary"
                                    :label="permission.label" class="mt-6">
                        </v-checkbox>
                    </div>
                </v-tab-item>
                <v-tab-item>
                    <div v-for="(permission, i) in authorizedPermissionsMeisterschaft" :key="i" class="mb-3">
                        <v-checkbox v-if="permission.type==='boolean'" hide-details
                                    v-model="permission.value" color="primary"
                                    :label="permission.label" class="mt-6">
                        </v-checkbox>
                    </div>
                </v-tab-item>
            </v-tabs>
        </div>
        <v-alert v-if="error" dense style="margin: auto" type="error" class="my-1 mx-5 mb-5">
            {{error}}
        </v-alert>
    </form-container>
</template>

<script>
    import {db} from "../../services/db"
    import {FormRules} from "../../services/formRules";
    import FormContainer from "../form/formContainer";
    import UserAdminService from "./userAdminService"

    export default {
        components: { FormContainer },
        name: "user-admin-edit-roles",
        props: ['currentObject'],
        data: () => ({
            error: '',
            rules: null,
            assignablePermissions: [],
            tab: 0
        }),
        computed: {
            adminUser(){
                return this.$store.state.user;
            },
            authorizedPermissions(){
                return this.assignablePermissions.filter(permission => permission.show &&
                                                         permission.tab === undefined );
            },
            authorizedPermissionsSport(){
                return this.assignablePermissions.filter(permission => permission.show &&
                    permission.tab === 0 );
            },
            authorizedPermissionsMeisterschaft(){
                return this.assignablePermissions.filter(permission => permission.show &&
                    permission.tab === 1 );
            },
        },
        created(){
            this.assignablePermissions = UserAdminService.getAssignablePermissions();
            this.rules = new FormRules();
            this.setCurrentPermissions();
        },
        methods: {
            setCurrentPermissions(){
                this.assignablePermissions.forEach( (permission) => {
                    if ( this.adminUser.permissions.userAdmin.updateRoles.indexOf(permission.name)!==-1 ) {
                        permission.show = true;
                        permission.value = this.currentObject.permissions[permission.name]
                    }
                });
            },
            save(){
                this.$store.state.local.loader = true;
                const updateObject = this.getUpdateObject();
                if ( Object.keys(updateObject).length > 0 ) {
                    this.update(updateObject);
                } else {
                    this.$store.state.local.loader = false;
                    window.history.back();
                }
            },
            update(updateObject){
                console.log ("updateObject", updateObject);
                db.collection("users").doc(this.currentObject.id).update(
                    updateObject
                )
                    .then(() => {
                        console.log("Document successfully updated!");
                        this.$store.state.local.loader = false;
                        window.history.back();
                    })
                    .catch((error) => {
                        // The document probably doesn't exist.
                        console.error("Error updating document: ", error);
                        this.$store.state.local.loader = false;
                    });
            },
                getUpdateObject(){
                    let updateObject = {};
                    this.authorizedPermissions.forEach( (permission) => {
                        if ( permission.value !== this.currentObject.permissions[permission.name] ) {
                            const fieldName = 'permissions.' + permission.name;
                            updateObject[fieldName] = permission.value;
                        }
                    });
                    this.authorizedPermissionsSport.forEach( (permission) => {
                        if ( permission.value !== this.currentObject.permissions[permission.name] ) {
                            const fieldName = 'permissions.' + permission.name;
                            updateObject[fieldName] = permission.value;
                        }
                    });
                    this.authorizedPermissionsMeisterschaft.forEach( (permission) => {
                        if ( permission.value !== this.currentObject.permissions[permission.name] ) {
                            const fieldName = 'permissions.' + permission.name;
                            updateObject[fieldName] = permission.value;
                        }
                    });
                    return updateObject;
                },
        },
        watch: {
            user: {
                handler(){
                    this.error = '';
                },
                deep: true
            },
        }
    }
</script>

<style scoped>

</style>